export default "__VITE_ASSET__2ae8671a__$_?component__"